/*
 * Project: LegalPlace assistant
 * File: src\logic\json_to_contract.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
 */



// import './jsonTestModel';
import { OPTIONS, VARIABLES, SECTIONS, CONTRACT_NAME, ARCHITECTURE } from './lp_map_utils';
// import { OptionWrapper } from './option_wrapper';
import { Section } from './section';
import lpApp from '../app/lp_app'
//These are names, don't worry about it



class Contract {
    s = {};
    name = "";
    sections = new Object();
    // TODO: optimize the code by cloning the `variables` and `options`
    variables = {};
    options = {};
    initial_options = []
    total_sections = 0;
    contract_version = 0;
    constructor( obj ) {
        this.s = obj;
        this.name = lpApp.references.customs.get('title');
        this.options = obj[OPTIONS];
        this.variables = obj[VARIABLES];
        this.contract_version = obj['version_id'];
        // 
        this.loadSection();
        this.total_sections = this.getTotalSections();
    }
    getTotalSections() {
            return Object.keys(this.sections).length;
        }
        // TODO: check secitons if they exist
    getSections() {
            if ( ARCHITECTURE in this.s )
                if ( SECTIONS in this.s[ARCHITECTURE] )
                    return this.s[ARCHITECTURE][SECTIONS]
            return null;
        }
        // check if the section exists
    checkSection( s_id ) {
        // here we'll do a lazy search by ID 
        // TODO: Accelerate the data retreiving by loading the sections in a sequential array
        var tmp = this.s[ARCHITECTURE][SECTIONS]
        for ( var i in tmp ) {
            if ( i == s_id )
                return i;
        }
        return false
    }
    loadSection() {
        var ss = this.s[ARCHITECTURE][SECTIONS];
        for ( var i in ss ) {
            // 
            this.sections[i] = new Section( ss[i] );
            // try the load fenyane for the sections
            this.sections[i].loadFenyan( this.options, this.variables );
        }
    }
}

export default Contract;



// WEBPACK FOOTER //
// ./src/logic/json_to_contract.js